// TODO add bold text
import { PROVIDER_TERMS_OF_SERVICE } from '@sly/core/constants/communityTOS';
import { CURRENT_YEAR } from '@sly/frontend/common/constants/year';

export default function LegalPageContentTOS() {
  return (
    <div
      data-tp-id='gen-div-25b79480-5df9-4e66-bc2b-4cbe030441eb'
      className='legal-page-content'
    >
      <h1>SENIORLY TERMS OF USE</h1>
      <h2>UPDATED JANUARY 1, {CURRENT_YEAR}</h2>
      <p>
        Hello and thank you for your interest in Seniorly, Inc. (“
        <b>Seniorly</b>”). By registering a new account or otherwise using or
        accessing any portion of the Seniorly website currently located at
        Seniorly.com (the “<b>Site</b>”), including any content, functionality,
        and services offered on or through the Site (collectively, the
        “Services”), you agree to the following terms of use, as updated from
        time to time (these “<b>Terms of Use</b>”). Please read these Terms of
        Use carefully. If you do not agree to these Terms of Use, do not use the
        Site, Partner Agents (as defined below), or Services.
      </p>
      <p>
        Notwithstanding anything to the contrary in these Terms of Use, these
        Terms of Use do not alter in any way the terms or conditions of any
        other agreement you may have with Seniorly for services, products, or
        otherwise. Your access to and use of the Site may also be subject to any
        legal notices or additional terms and conditions applicable to the Site
        and/or Services, in addition to these Terms of Use (“
        <b>Additional Terms</b>”). Where Additional Terms apply to the Site or
        Services, the Additional Terms will be provided to you separately. These
        Terms of Use, together with the Additional Terms, form a legally binding
        agreement between you and Seniorly in relation to your use of the Site
        and Services. If there is any contradiction between what the Additional
        Terms say and what these Terms of Use say with respect to the Services,
        then the Additional Terms shall take precedence in relation to the
        particular Service.
      </p>
      <p>
        You must be at least eighteen (18) years of age to use the Site or
        Services. By agreeing to these Terms of Use, you represent and warrant
        that: (a) you are at least eighteen (18) years of age; (b) you have not
        previously been suspended or removed from the Site or prohibited use of
        any Services; and (c) your registration and your use of the Site and any
        Services complies with all applicable laws and regulations. If you do
        not meet all of these requirements, you must not access or use the Site
        or any Services offered on or through the Site.
      </p>
      <p>
        Unless you have entered into a separate written commercial agreement
        with Seniorly permitting you to use the Services for transactions on
        behalf of another person, you may only use the Services for transactions
        on your own behalf, and not on behalf of any other person.
      </p>
      <h3>CHANGES TO THESE TERMS OF USE</h3>
      <p>
        We reserve the right to change or modify theses Terms of Use and
        anything pertaining to the Site, Partner Agents, and/or Services at any
        time in our sole discretion. If we decide to change these Terms of Use,
        we will post a new version on the Site and update the date listed at the
        top of these Terms of Use. Any changes or modifications will be
        effective immediately upon posting of the revisions on the Site.
        However, any such changes will not apply to any dispute between you and
        Seniorly arising prior to the date on which we posted the revised Terms
        of Use incorporating such changes. Your use of the Site and/or the
        Services following the posting of changes or modifications to these
        Terms of Use will constitute your acceptance of the revised Terms of
        Use. If you do not agree to the amended terms, you should immediately
        stop using the Site and Services. You are expected to check this page
        from time to time so you are aware of any changes, as they are binding
        on you.
      </p>
      <h3>OUR SERVICES</h3>
      <p>
        Seniorly is a senior living information portal that lists senior living
        and care services. Seniorly works with independent living, residential
        care homes, assisted living, memory care, skilled nursing, and similar
        facilities (“<b>Participating Communities</b>”). Seniorly also works
        with local placement agents and geriatric care managers to assist
        families in person or over the phone (each a “<b>Partner Agent</b>”).
        Based on a family’s stated needs and preferences, we provide such family
        with information about contracted Participating Communities and we
        forward such family’s information to those Participating Communities or
        Partner Agents, as applicable. Families can review detailed information
        about local and national Participating Communities, and get
        personalized, knowledgeable assistance by telephone or in-person from a
        local Partner Agent. Unless otherwise specified, Seniorly’s service is
        offered at no charge to families as the Participating Communities pay a
        fee to Seniorly or its Partner Agents. In connection with the paid
        services, Seniorly also operates a proprietary software platform for use
        by approved Participating Communities and Partner Agents.
      </p>
      <h3 id='participating-communities'>PARTICIPATING COMMUNITIES</h3>
      <p>
        The Participating Communities are solely responsible for evaluating,
        accepting (or declining, as appropriate), and caring for all residents,
        including ensuring that their staff are appropriately qualified, current
        on education, and possess the necessary facilities, resources, and
        equipment to competently provide the services and care required by its
        residents, whether referred from Seniorly or a Partner Agent. Each
        Participating Community is responsible for the conditions at its
        community and the training of and acts and omissions of its employees,
        contractors, vendors, and any other individual who works at or for a
        community.
      </p>
      <p>
        We do not ensure the accuracy of any of the information posted by and/or
        for a Participating Community on the Site, and do not take any
        responsibility or assume any liability for any actions you may take as a
        result of reading the information posted by and/or for a Participating
        Community on the Site. By using the Site and/or Services, you assume all
        associated risks.
      </p>
      {PROVIDER_TERMS_OF_SERVICE.map((text, index) => (
        <p key={index}>{text}</p>
      ))}

      <h3>NO ENDORSEMENT; NO AFFILIATION; NOT A BROKER</h3>
      <p>
        We, and Partner Agents, exercise no independent judgment as to the
        quality of, nor do we recommend, control, or endorse, any Participating
        Community. We provide only an information service and do not: (a) place
        the consumer in any Participating Community; (b) perform any medical
        assessment of or for the consumer or the Participating Community; or (c)
        participate in the consumer’s and Participating Community’s decision
        regarding final selection or admittance. Further, we are not a
        representative of or agent for either the consumer or the Participating
        Community and do not act on either’s behalf. It is the responsibility
        solely of the Participating Community and the potential resident, and/or
        the potential resident’s family and care provider(s) and/or other
        involved parties acting on the potential resident’s behalf, to determine
        if any person is an appropriate admission to the Participating
        Community.
      </p>
      <h3>NO PROFESSIONAL ADVICE</h3>
      <p>
        All information, materials, content, and advice on the Site or provided
        through the Services is for informational purposes only and is not
        intended to replace or substitute any professional, financial, medical,
        legal, or other advice. Seniorly expressly disclaims, and you expressly
        release Seniorly from, any and all liability concerning any treatment,
        action by, or effect on any person following the information offered or
        provided within or through the Site and/or Services. You should consult
        with an appropriately trained specialist for all concerns that require
        medical, legal, financial, or other professional advice.
      </p>
      <h3>FEES</h3>
      <p>
        A. Generally. You may be required to pay fees to access certain features
        of the Site or Services. All fees are in U.S. dollars and are
        non-refundable. If Seniorly implements, changes, modifies, or waives the
        fees for all or part of the Services, including by adding fees or
        charges, Seniorly will provide you advance notice of those changes. If
        you do not accept the changes, Seniorly may restrict your access to
        certain features of the Site or discontinue providing the applicable
        part of the Services to you. Seniorly’s authorized third-party payment
        processor will charge the payment method you specified at the time of
        purchase. You authorize Seniorly to charge all fees as described in
        these Terms of Use for the Services you select to that payment method,
        and you grant Seniorly the right to provide such information to third
        parties for purposes of facilitating any transactions. If you pay any
        fees with a credit card, you represent and warrant that you have the
        right to use any credit card that you submit, and Seniorly may seek
        pre-authorization of your credit card account before your purchase to
        verify that the credit card is valid and has the necessary funds or
        credit available to cover your purchase.
      </p>
      <p>
        B. Subscriptions. The Services may include features that allow for
        automatically recurring payments for periodic charges (“
        <b>Subscription Service</b>”). If you decide to activate a Subscription
        Service, you authorize Seniorly to periodically charge, on a
        going-forward basis and until cancellation of either the recurring
        payments or your account, all accrued sums on or before the payment due
        date for the accrued sums. The subscription will continue unless and
        until you cancel your subscription, or we terminate it. You must cancel
        your subscription before it renews in order to avoid billing of the next
        periodic subscription fee to your account. We will bill the periodic
        subscription fee to the payment method you provide to us during
        registration (or to a different payment method if you change your
        payment information). Seniorly may change the subscription fee for any
        subsequent subscription period but will provide you advance notice of
        any increase before it applies.
      </p>
      <h3>USER ACCOUNTS; USER MATERIALS</h3>
      <p>
        A. User Accounts. To access some features of the Site and/or Services,
        you may be required to register for an account. When you register for an
        account, you may be required to provide us with some information about
        yourself, such as email address or other contact information. You
        represent and warrant that the information you provide is accurate and
        complete and that you will keep it accurate, complete, and up to date at
        all times. When you register, you may be asked to provide a password.
        You are solely responsible for maintaining the confidentiality of your
        account and password, and you are responsible for all actions taken via
        your account. You also acknowledge that your account is personal to you,
        and you agree not to provide any other person with access to the Site or
        portions of it using your user name, password, or other security
        information. You agree to notify us immediately of any unauthorized
        access to or use of your user name or password or any other breach of
        security. You also agree to ensure that you exit from your account at
        the end of each session. You should use particular caution when
        accessing your account from a public or shared computer so that others
        are not able to view or record your password or other personal
        information. We have the right to disable any user name, password, or
        other identifier, whether chosen by you or provided by us, at any time
        in our sole discretion for any or no reason, including, in our opinion,
        you have violated any provision of these Terms of Use.
      </p>
      <p>
        B. User Materials; License Grant. Certain portions of the Services may
        allow users to upload or otherwise provide to Seniorly images, photos,
        video, data, text, listings, and other content (“<b>User Materials</b>
        ”). By uploading or otherwise providing User Materials to the Services,
        you grant Seniorly an irrevocable, perpetual, royalty-free worldwide,
        fully paid-up, transferable, and fully sublicensable (through multiple
        tiers) license to use, copy, distribute, transmit, publicly display,
        publicly perform, reproduce, edit, modify, prepare derivative works of
        or incorporate into other works, translate, and otherwise use, analyze,
        and exploit your User Materials, in any format or media now known or
        hereafter developed, and for any purpose (including promotional
        purposes, such as testimonials). Seniorly will not pay you for your User
        Materials or to exercise any rights related to your User Materials.
        Seniorly has no control over and is not responsible for any use or
        misuse (including any distribution) by any third party of User
        Materials. Seniorly may remove or modify your User Materials at any
        time. You are solely responsible for all User Materials made through
        your user account(s) on the Services or that you otherwise make
        available through the Services. For all User Materials, you represent
        and warrant that: (i) you are the creator and owner of the User
        Materials, or have the necessary licenses, rights, consents, and
        permissions (including all permissions required under applicable privacy
        and intellectual property laws) to authorize Seniorly and other users to
        access and use your User Materials as necessary to exercise the licenses
        granted by you under these Terms of Use; and (ii) your provision of User
        Materials is not fraudulent, tortious, or otherwise in violation of any
        applicable law or any right of any third party. You further irrevocably
        waive any “moral rights” or other rights with respect to attribution of
        authorship or integrity of materials regarding any User Materials that
        you may have under any applicable law under any legal theory. In
        addition, if you provide to us any ideas, proposals, suggestions, or
        other materials (“<b>Feedback</b>”), whether related to the Site and/or
        Services or otherwise, such Feedback will be deemed User Materials, and
        you hereby acknowledge and agree that such Feedback is not confidential,
        and that your provision of such Feedback is gratuitous, unsolicited, and
        without restriction, and does not place Seniorly under any fiduciary or
        other obligation. IF YOU CHOOSE TO MAKE ANY OF YOUR PERSONALLY
        IDENTIFIABLE OR OTHER INFORMATION PUBLICLY AVAILABLE THROUGH THE SITE,
        YOU DO SO AT YOUR OWN RISK.
      </p>
      <p>
        C. User Materials Disclaimer. Seniorly is under no obligation to
        monitor, evaluate, edit, or control your User Materials or the User
        Materials of any other user and will not be in any way responsible or
        liable for any User Materials. Seniorly may, however, at any time and
        without prior notice, screen, remove, edit, or block any User Materials
        on the Services, including User Materials, that in Seniorly’s sole
        judgment violate these Terms of Use or are otherwise objectionable,
        including in any way described in our Privacy Policy. You understand
        that when using the Services, you may be exposed to User Materials of
        other users and acknowledge that User Materials may be inaccurate,
        offensive, indecent, or objectionable. You agree to waive, and do waive,
        any legal or equitable right or remedy you may have against Seniorly
        with respect to User Materials. Seniorly expressly disclaims any and all
        liability in connection with User Materials. If notified by a user or
        content owner that User Materials allegedly do not conform with these
        Terms of Use, Seniorly may investigate the allegation and determine in
        Seniorly’s sole discretion whether to remove the User Materials, which
        Seniorly reserves the right to do at any time and without notice.
      </p>
      <h3>PRIVACY AND CONSENT TO COMMUNICATIONS</h3>
      <p>
        Your privacy is important to us, and we provide a Privacy Policy that
        sets out how we collect and use your personal information collected from
        the Site. Please review our Privacy Policy to which you should refer to
        fully understand how we collect and use personal information; your use
        of the Site and/or Services will constitute your acceptance of the terms
        and conditions of the Privacy Policy. By filling out any forms on the
        Site or providing information to us, you expressly consent to being
        contacted by us and/or the Participating Communities, whether by phone,
        mobile phone, email, mail, or otherwise. If you are a customer or
        potential customer of the Services, you authorize us to provide the
        information that you provided us and related information we may receive
        from third parties to Participating Communities for the purpose of
        providing Services. Such authorization shall continue in effect until
        you have withdrawn your consent by requesting that we no longer provide
        you Services; provided that we may continue to refer to and/or disclose
        your information when communicating with a Participating Community as
        necessary for our normal Participating Community related business
        practices (such as Participating Community billing matters) until such
        matters are closed.
      </p>
      <p>
        The Services may provide web forms, links, or contact information,
        including phone numbers, that can connect you with Seniorly or third
        parties, such as Partner Agents or Participating Communities.
        Communications through these methods may be routed through a third-party
        service (“<b>Communications Service</b>”). Calls may be recorded or
        monitored for quality assurance and customer service purposes. You will
        be notified at the beginning of a call if it may be recorded or
        monitored. You consent to such recording and monitoring by Seniorly or
        the Communications Service. Seniorly also uses the Communications
        Service to track phone calls and text messages between you and Partner
        Agents so that Seniorly and the Partner Agent can access certain details
        about the contact. As part of this process, Seniorly and the
        Communications Service will receive in real time, and store, data about
        your call or text message, including the date and time of the call or
        text message, your phone number, and the content of the text message.
        You consent to these practices by Seniorly and the Communications
        Service. The information is subject to the Privacy Policy.
      </p>
      <h3>USE OF SITES; LIMITED LICENSE</h3>
      <p>
        You are granted a limited, non-sublicensable license to access and use
        the Site and all content, data, information, and materials included on
        the Site (the “<b>Site Materials</b>”) solely for your personal use,
        subject to the terms and conditions set forth in these Terms of Use. You
        will not use the Site or any of the Site Materials other than for their
        intended purpose or in any way that is unlawful or harms Seniorly. Any
        use of the Site or the Site Materials other than as specifically
        authorized herein is strictly prohibited and, without limiting other
        available remedies, will automatically and immediately terminate the
        license granted herein. Such unauthorized use may also violate
        applicable laws including copyright and trademark laws and applicable
        communications regulations and statutes. Unless explicitly stated
        herein, nothing in these Terms of Use shall be construed as conferring
        any license to intellectual property rights, whether by estoppel,
        implication, or otherwise. This license is revocable by Seniorly at any
        time.
      </p>
      <h3>PROHIBITED USE</h3>
      <p>
        The following are examples of some actions and activities that are
        prohibited by you in accessing or using the Site or Services, and you
        agree not to do any of the following:
      </p>
      <ul>
        <li>Using the Site for commercial purposes.</li>
        <li>
          Conducting or promoting any illegal activities while using the Site or
          Services.
        </li>
        <li>
          Uploading or attempting to upload or otherwise transferring any virus,
          worm, trap door, back door, Trojan horse, timer, clock, counter, or
          other limiting or malicious routine, instruction, or design that would
          cause harm to the Site or Seniorly’s computer or telecommunication
          systems or data.
        </li>
        <li>
          Interfering in any way with the proper functioning of the Site
          (including harming, disabling, or significantly slowing) or
          interfering with or disrupting any servers or networks connected to
          the Site, or disobeying any requirements, procedures, policies, or
          regulations of networks connected to the Site.
        </li>
        <li>
          Modifying, copying, distributing, reselling, transmitting, displaying,
          performing, reproducing, publishing, licensing, creating derivative
          works from, framing in another web page, and/or using on any other
          website or service any of the Site Materials.
        </li>
        <li>
          Engaging in the practices of “screen scraping,” “database scraping,”
          “data mining” or any other activity with the purpose of obtaining
          lists of users or other information, in whole or in part, from the
          Sites or use web “bots” or similar data gathering or extraction
          methods for such purposes.
        </li>
        <li>
          Attempting to reverse engineer or jeopardize the correct functioning
          of the Site, or otherwise attempting to derive the source code of the
          software (including the tools, methods, processes, and infrastructure)
          that enables or underlies the Site.
        </li>
        <li>Attempting to gain access to secured portions of the Site.</li>
        <li>
          Circumventing, attempting to circumvent, disabling, or attempting to
          disable, or discovering or attempting to discover, any security
          measures (including encryption algorithms, keys, passwords, and the
          like) used by or for Seniorly to protect its computer and/or
          telecommunications systems.
        </li>
        <li>
          Using the Site or Services to generate unsolicited email
          advertisements or spam; or allowing, enabling, or otherwise supporting
          the transmission of mass unsolicited, commercial advertising or
          solicitations via e-mail (i.e., “spam”).
        </li>
        <li>
          Using the Site or Services to stalk, harass, or harm another
          individual.
        </li>
        <li>
          Impersonating any person or entity, or otherwise misrepresenting your
          affiliation with a person or entity.
        </li>
        <li>
          Posting, transmitting, or otherwise making available through or in
          connection with the Site any materials that are or may be: (a)
          threatening, harassing, degrading, hateful, or intimidating, or
          otherwise fail to respect the rights and dignity of others; (b)
          defamatory, libelous, fraudulent, or otherwise tortious; (c) obscene,
          indecent, pornographic, or otherwise objectionable; (d) protected by
          copyright, trademark, trade secret, right of publicity or privacy, or
          any other proprietary right, without the express prior written consent
          of the applicable owner; or (e) harmful to minors.
        </li>
        <li>
          Mirroring or framing the Site, placing pop-up windows over its pages,
          or otherwise affecting the display of its pages.
        </li>
        <li>
          Removing any copyright, trademark, or other proprietary rights notice
          from the Site or from any materials made available on or through the
          Site.
        </li>
        <li>
          Engaging in any other action in any way that is unlawful or harms
          Seniorly.
        </li>
      </ul>
      <h3>INTELLECTUAL PROPERTY OWNERSHIP</h3>
      <p>
        The Seniorly, Inc. name, the Seniorly, Inc. logo, and all related names,
        logos, product and service names, designs, slogans, and other marks
        contained on the Site or in materials provided by Seniorly are
        trademarks of Seniorly or its affiliates or licensors. You must not use
        such marks without the prior written permission of Seniorly. All other
        names, logos, product and service names, designs, and slogans on the
        Site are the trademarks of their respective owners. All rights, title,
        and interest in and to the Site, including content, materials,
        trademarks, software, and other features and functionality, and all
        intellectual property relating to the Site, vest solely in Seniorly and
        its licensors.
      </p>
      <p>
        You may not use Seniorly’s marks in connection with any product or
        service that is not Seniorly’s, or in any manner that is likely to cause
        confusion. Nothing contained on the Site should be construed as granting
        any right to use any such marks without the express prior written
        consent of the owner. Any rights not expressly granted herein are
        reserved.
      </p>
      <h3>THIRD-PARTY AND LINKED SERVICES</h3>
      <p>
        The Services include links to third-party products, services, and
        websites, as well as materials provided by third parties, and may
        include functionality that allows for the distribution of your User
        Materials or your personal information (collectively, your “
        <b>User Information</b>”) to third parties not under Seniorly’s control
        (each, a “<b>Third-Party Provider</b>”). The Site may provide links to
        external sites (“<b>External Sites</b>”). We provide these links to
        External Sites for your convenience only. We do not control such
        External Sites; therefore, Seniorly is not responsible for the content
        of any linked website or any link contained in a linked website. Our
        inclusion of links to such External Sites does not imply any endorsement
        of any such third party who advertises their goods or services through
        the Site (including Participating Communities and Partner Agents). We
        make no claim or representation regarding, and accept no responsibility
        for, the quality, content, nature, or reliability of External Sites.
      </p>
      <p>
        Third-Party Providers are solely responsible for their services. You are
        responsible for your use and submission of User Information to any third
        party, and your dealings or business conducted with any third party
        arising in connection with the Services are solely between you and such
        third party. Your use of third-party sites, services, or products may be
        subject to associated third-party terms of use and privacy policies or
        other agreements, which you are solely responsible for complying with.
        Seniorly does not endorse, and takes no responsibility for such
        products, services, websites, and materials, or a Third-Party Provider’s
        use of your User Information. By using a tool that allows for User
        Information to be transferred, you agree that Seniorly may transfer the
        applicable User Information or other information to the applicable third
        parties, which are not under the control of Seniorly. If you submit a
        contact form or otherwise indicate your interest in contacting a
        Third-Party Provider, you may receive telemarketing calls from the
        Third-Party Provider using the contact information you provided.
        Third-Party Providers may keep your contact information and any other
        information received by the Third-Party Provider in processing a contact
        or other request form. Seniorly is not responsible for any damages or
        costs of any type arising out of or in any way connected with your
        dealings with these third parties.
      </p>
      <h3>COPYRIGHT INFRINGEMENT NOTICES AND DMCA NOTICES</h3>
      <p>
        The Digital Millennium Copyright Act of 1998 (the “<b>DMCA</b>”)
        provides recourse for copyright owners who believe that material
        appearing on the Internet infringes their rights under U.S. copyright
        law. If you believe in good faith that materials available on the Site
        infringe your copyright, you (or your agent) may send to Company a
        written notice by mail, e-mail or fax, requesting that Company remove
        such material or block access to it. If you believe in good faith that
        someone has wrongly filed a notice of copyright infringement against
        you, the DMCA permits you to send to Company a counter-notice. Notices
        and counter-notices must meet the then-current statutory requirements
        imposed by the DMCA. See{' '}
        <a href='https://www.copyright.gov/'>https://www.copyright.gov/</a> for
        details.
      </p>
      <p>
        Notices and counter-notices must be sent in writing to Seniorly as
        follows: By mail to Seniorly, Inc., Attn: DMCA Agent, P.O. Box 26804,
        San Francisco, CA, 94108, USA; or by e-mail to legal@seniorly.com. You
        also may contact Seniorly’s DMCA Agent at telephone number (415)
        985-4958.
      </p>
      <h3>DISCLAIMER</h3>
      <p>
        THE SITE AND THE SITE MATERIALS (INCLUDING ALL THIRD-PARTY CONTENT), AND
        ALL LINKS, INFORMATION, MATERIALS, EVALUATIONS, RECOMMENDATIONS,
        PRODUCTS, AND OTHER SERVICES PROVIDED ON OR THROUGH THE SITE ARE
        PROVIDED ON AN “AS IS” BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER
        EXPRESS OR IMPLIED. YOU EXPRESSLY AGREE THAT USE OF THE SITE AND THE
        SERVICES IS AT YOUR SOLE RISK. SENIORLY AND ITS AFFILIATES, SUCCESSORS,
        OFFICERS, DIRECTORS, SHAREHOLDERS, PERSONAL REPRESENTATIVES, AGENTS, AND
        EMPLOYEES (COLLECTIVELY, “<b>ASSOCIATED PARTIES</b>”) DISCLAIM ALL
        WARRANTIES, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
        NON-INFRINGEMENT AS TO THE SITE, THE SITE CONTENT, LINKS, AND ALL
        INFORMATION, MATERIALS, PRODUCTS, AND OTHER SERVICES AVAILABLE ON OR
        THROUGH THE SITE OR SERVICES. IN ADDITION, SENIORLY IS NOT RESPONSIBLE
        FOR THE INFORMATION, PRODUCTS, OR SERVICES PROVIDED BY, OR THE CONDUCT
        OF, ANY THIRD PARTY OR ITS AGENTS OR EMPLOYEES (EVEN IF WE HAVE
        INTRODUCED YOU TO SUCH PARTY OR PARTIES), INCLUDING ANY PARTICIPATING
        COMMUNITY, PARTNER AGENT, OR OTHER HEALTH CARE OR ANY OTHER SENIOR
        HOUSING AND CARE PROVIDER, WHETHER OFFLINE OR ONLINE. NO ORAL OR WRITTEN
        INFORMATION FROM SENIORLY OR ANY OTHER PARTY WILL MODIFY THIS
        DISCLAIMER. SENIORLY EXPRESSLY DISCLAIMS ANY REPRESENTATIONS,
        WARRANTIES, OR COVENANTS THAT THE INFORMATION OR MATERIALS ON THE SITE
        ARE ACCURATE, COMPLETE, RELIABLE, CURRENT, OR ERROR-FREE. WHILE WE
        ATTEMPT TO PROVIDE YOU ACCESS SAFE FROM VIRUSES, SENIORLY DOES NOT
        REPRESENT, WARRANT, OR COVENANT THAT THE SITE OR ITS SERVER(S) ARE FREE
        OF VIRUSES OR OTHER HARMFUL COMPONENTS.
      </p>
      <h3>LIMITATION OF LIABILITY</h3>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL
        SENIORLY OR ANY OF THE ASSOCIATED PARTIES BE LIABLE FOR ANY DIRECT,
        SPECIAL, PUNITIVE, EXEMPLARY, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL
        DAMAGES, OR ANY OTHER DAMAGES OF ANY KIND WHATSOEVER, INCLUDING LOSS OF
        USE, LOSS OF PROFITS, OR LOSS OF DATA OR OTHER INFORMATION, FOR BUSINESS
        INTERRUPTION, OR FOR ANY OTHER PECUNIARY OR OTHER LOSS WHATSOEVER)
        ARISING OUT OF OR IN ANY WAY RELATED TO THE SITE OR SERVICES, SENIORLY’S
        ACTS OR OMISSIONS UNDER OR IN ANY WAY RELATED TO THE SITE OR SERVICES,
        OR OTHERWISE UNDER OR IN CONNECTION WITH THE SITE OR SERVICES,
        REGARDLESS OF THE LEGAL THEORY, INCLUDING TORT, STRICT LIABILITY, BREACH
        OF CONTRACT, OR BREACH OF WARRANTY BY SENIORLY OR ANY OF THE ASSOCIATED
        PARTIES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
        DAMAGES. YOUR SOLE AND EXCLUSIVE REMEDY FOR DISSATISFACTION WITH THE
        SITE OR ANY SERVICES IS TO STOP USING THE SITE AND SERVICES. THE MAXIMUM
        AGGREGATE LIABILITY OF SENIORLY FOR ALL DAMAGES, LOSSES, AND CAUSES OF
        ACTION, WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE,
        SHALL BE THE TOTAL AMOUNT, IF ANY, PAID BY YOU TO SENIORLY TO USE THE
        SITE AND/OR SERVICES. ALL LIMITATIONS OF LIABILITY OF ANY KIND
        (INCLUDING IN THIS SECTION 15 (LIMITATION OF LIABILITY) AND ELSEWHERE IN
        THIS AGREEMENT) ARE MADE ON BEHALF OF BOTH SENIORLY AND EACH OF THE
        ASSOCIATED PARTIES AND THEIR RESPECTIVE SUCCESSORS AND ASSIGNS. THE
        FOREGOING LIMITATIONS, EXCLUSIONS, AND DISCLAIMERS OF THIS SECTION 15
        (LIMITATION OF LIABILITY) SHALL APPLY TO THE MAXIMUM EXTENT PERMITTED BY
        APPLICABLE LAW, EVEN IF ANY REMEDY FAILS ITS ESSENTIAL PURPOSE. SOME
        JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF CONSEQUENTIAL
        OR INDIRECT DAMAGES, SO THE ABOVE EXCLUSIONS AND LIMITATIONS MAY NOT
        APPLY TO YOU.
      </p>
      <h3>INDEMNIFICATION</h3>
      <p>
        You agree to defend, indemnify, and hold Seniorly and each of the
        Associated Parties, and their respective successors and assigns,
        harmless from any claim or demand, including attorneys’ fees, arising
        out of your use of the Sites and/or Services or your violation or
        alleged violation of these Terms of Use, or the infringement by you of
        any intellectual property or other right of any person or entity.
      </p>
      <h3>TERMINATION</h3>
      <p>
        These Terms of Use are effective until terminated. We may terminate or
        suspend your access to the Site and/or your use of Services at any time,
        with or without cause, and with or without notice. Upon such termination
        or suspension, your right to use the Site and/or Services, as
        applicable, will immediately cease. Sections 1-5, 6 (to the extent
        applicable with respect to any Subscription Service that remains in
        effect or for which any fees remain payable), 7-8, and 10-24 shall
        survive any expiration or termination of these Terms of Use.
      </p>
      <h3>CHANGES TO THE SITE AND/OR SERVICES</h3>
      <p>
        We reserve the right to change, modify, suspend, or cease providing the
        Site and/or any Services (and, therefore, your access to and use of the
        foregoing) at any time, without notice.
      </p>
      <h3>JURISDICTIONAL ISSUES</h3>
      <p>
        The Site is controlled or operated (or both) from the United States and
        is not intended to subject Seniorly to any non-U.S. jurisdiction or law.
        The Site may not be appropriate or available for use in some non-U.S.
        jurisdictions. Any use of the Site is at your own risk, and you must
        comply with all applicable laws, rules, and regulations in doing so. We
        may limit the Site’s availability at any time, in whole or in part, to
        any person, geographic area, or jurisdiction that we choose in our sole
        discretion.
      </p>
      <h3>CHOICE OF LAW</h3>
      <p>
        These Terms of Use are governed by the laws of the State of California,
        without giving effect to its conflict of laws provisions and regardless
        of your location. You agree to submit to the personal and exclusive
        jurisdiction and venue in the state and federal courts sitting in San
        Francisco County, California for any and all disputes, claims, and
        actions arising from or in connection with the Site, the Services,
        and/or these Terms of Use.
      </p>
      <h3>CLAIMS SUBJECT TO MANDATORY AND BINDING ARBITRATION</h3>
      <p>
        Subject to and without limiting Section 20 (Choice of Law), you
        expressly agree that any claim or cause of action that arises from,
        relates to, or has connection with the Site or Services shall be
        adjudicated exclusively and finally by arbitration in California,
        administered by the American Health Lawyers Association Alternative
        Dispute Resolution Service under its Rules of Procedure for Arbitration
        (available at{' '}
        <a href='http://www.healthlawyers.org'>http://www.healthlawyers.org</a>
        ). The arbitration award shall be final and binding, and judgment on the
        award rendered by the arbitrator(s) may be entered in any court having
        jurisdiction thereof. Except as required by applicable law, you
        knowingly, voluntarily, intelligently, and irrevocably waive any right
        to appeal from the arbitration award, including any appeal from any
        judgment entered on the arbitration award or any order based thereupon.
        YOU EXPRESSLY AGREE THAT ANY CLAIM OR CAUSE OF ACTION THAT IS SUBJECT TO
        ARBITRATION UNDER THESE TERMS OF USE MUST BE BROUGHT IN YOUR INDIVIDUAL
        CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS
        OR REPRESENTATIVE PROCEEDING. YOU FURTHER EXPRESSLY AGREE THAT THE
        ARBITRATOR SHALL NOT CONSOLIDATE MORE THAN ONE PERSON’S CLAIMS AND MAY
        NOT OTHERWISE PRESIDE OVER ANY FORM OF A REPRESENTATIVE OR CLASS
        PROCEEDING. ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR
        RELATING TO THESE TERMS OF USE OR THE SITE MUST BE COMMENCED WITHIN ONE
        (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES; OTHERWISE, SUCH CAUSE OF
        ACTION OR CLAIM IS PERMANENTLY BARRED. If a court decides that the terms
        of this Section 21 (Claims Subject to Mandatory and Binding Arbitration)
        are not enforceable or are invalid, then this Section 21 (Claims Subject
        to Mandatory and Binding Arbitration) shall cease to have effect;
        provided, however, that the remaining portions of these Terms of Use
        will remain in full force and effect.
      </p>
      <h3>FILTERING</h3>
      <p>
        We hereby notify you that parental control protections (such as computer
        hardware, software, or filtering services) are commercially available
        that may assist you in limiting access to material that is harmful to
        minors. Information identifying current providers of such protections is
        available from{' '}
        <a href='https://en.wikipedia.org/wiki/Comparison_of_content-control_software_and_providers'>
          https://en.wikipedia.org/wiki/Comparison_of_content-control_software_and_providers
        </a>
        . Please note that Seniorly does not endorse any of the products or
        services listed on such site.
      </p>
      <h3>GENERAL TERMS</h3>
      <p>
        You agree not to export from anywhere any part of the Services provided
        to you, or any direct product thereof, except in compliance with, and
        with all licenses and approvals required under, applicable export laws,
        rules, and regulations. You represent, warrant, and covenant that you
        are not: (a) located in, or a resident or a national of, any country
        subject to any U.S. government embargoes or other sanctions or
        restrictions; or (b) on any of the U.S. government lists of restricted
        persons or entities. All Services used by the U.S. Government are
        provided with the commercial license rights described herein. These
        Terms of Use do not, and shall not be construed to, create any
        partnership, joint venture, employer-employee, agency, or
        franchisor-franchisee relationship between you and Seniorly. These Terms
        of Use may only be amended by a written agreement signed by authorized
        representatives of the parties to these Terms of Use. If any part of
        these Terms of Use is determined to be invalid or unenforceable, then
        the invalid or unenforceable provision will be replaced with a valid and
        enforceable provision that most closely matches the intent of the
        original provision and the remainder of these Terms of Use will continue
        in effect. The section headings in these Terms of Use are solely used
        for the convenience of the parties and have no legal or contractual
        significance. All terms defined in the singular shall have the same
        meanings when used in the plural, where appropriate and unless otherwise
        specified. Any use of the term “including” or variations thereof in
        these Terms of Use shall be construed as if followed by the phrase
        “without limitation.” Seniorly may assign this Agreement, in whole or in
        part, at any time with or without notice to you. You may not assign
        these Terms of Use, or assign, transfer, or sublicense your rights or
        obligations, if any, in the Services. Seniorly’s failure to act with
        respect to a breach by you or others does not waive its right to act
        with respect to subsequent or similar breaches. Except as expressly
        stated herein, these Terms of Use, and all expressly incorporated terms
        and agreements, constitute the entire agreement between you and Seniorly
        with respect to the Services provided hereunder and supersede all prior
        or contemporaneous communications of any kind between you and Seniorly
        with respect to the Services. Notices to you (including notices of
        changes to these Terms of Use) may be made via posting to the Site or by
        e-mail (including in each case via links), or by regular mail. Without
        limitation, a printed version of these Terms of Use and of any notice
        given in electronic form shall be admissible in judicial or
        administrative proceedings based upon or relating to these Terms of Use
        to the same extent and subject to the same conditions as other business
        documents and records originally generated and maintained in printed
        form. Seniorly will not be responsible for any failure to fulfill any
        obligation due to any cause beyond its control.
      </p>
      <h3>CONTACT INFORMATION</h3>
      <p>
        The Services are offered by Seniorly and its affiliates, located at 2
        Embarcadero Center, Suite 08-129, San Francisco, CA, 94111. You may
        contact Seniorly by sending correspondence to that address or emailing
        info@seniorly.com. Please note that e-mail communications will not
        necessarily be secure; accordingly, you should not include credit card
        information or other sensitive information in your e-mail correspondence
        with us. California residents may reach the Complaint Assistance Unit of
        the Division of Consumer Services of the California Department of
        Consumer Affairs by mail at 1625 North Market Blvd., Sacramento, CA,
        95834, or by telephone at (916) 445-1254 or (800) 952-5210.
      </p>
    </div>
  );
}
